import React from "react";
import { Button } from "../../shadcn/button";

const OutlineButton = ({
  icon,
  text,
  disabled,
  onClick,
  style,
  ref,
  ...props
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      className="bg-white text-gray-700 border border-gray-300 font-inter font-semibold text-sm leading-5 tracking-normal px-4 py-2.5 rounded-lg inline-flex items-center justify-center gap-2 w-fit transition-shadow duration-200 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ ...style }}
      {...props}
    >
      {icon}
      {text}
    </Button>
  );
};

export default OutlineButton;
